module.exports = __webpack_public_path__ + "img/img8.666e4d40.svg";